<template>
  <customer 
    v-if="model" 
    :customer="model" 
    :enable_details="false"
  ></customer>
</template>

<script>
import Customer from "./Details/ValidationRequestable/Customer"

export default {
  name:"ModelCustomer",

  props:["model"],

  components:{
    Customer,
  }
}
</script>



// WEBPACK FOOTER //
// client/components/Demands/ModelCustomer.vue